module.exports = __webpack_public_path__ + "static/media/baseMeme7thumb.1bab11a9.jpg";